import {SectionModuleTypeEnum} from "@/scripts/common/enums.js";

const IMAGE_ONLY_COLUMNS_BY_ASPECT_RATIO = {
    "1_1": 6,
    "3_4": 4,
    "9_16": 4
};

const MOBILE_MOCKUP_TYPES = new Set(["Mobile", "Tablet"]);
const WIDE_MOCKUP_TYPES = new Set(["Laptop", "Desktop", "Monitor"]);

export function getTabsContentModules(modules = []) {
    return Array.isArray(modules)
        ? modules.filter(module => module?.type !== SectionModuleTypeEnum.SPACER)
        : [];
}

export function hasTabsModule(modules, moduleType) {
    return getTabsContentModules(modules).some(module => module.type === moduleType);
}

export function isTabsTextOnly(modules) {
    const contentModules = getTabsContentModules(modules);
    return contentModules.length === 1 && contentModules[0]?.type === SectionModuleTypeEnum.TEXT;
}

export function getTabsInternalGridColumns(tab, modules) {
    if (isTabsTextOnly(modules)) return 12;

    const deviceType = tab?.media?.mockupSettings?.deviceType;
    if (MOBILE_MOCKUP_TYPES.has(deviceType)) return 8;
    if (WIDE_MOCKUP_TYPES.has(deviceType)) return 10;
    return 12;
}

export function getTabsImageOnlyColumnSpan(aspectRatio = "16_9") {
    return IMAGE_ONLY_COLUMNS_BY_ASPECT_RATIO[aspectRatio] || 8;
}

export function getTabsMediaOnlyColumnSpan(tab, modules, aspectRatio = "16_9") {
    const contentModules = getTabsContentModules(modules);
    const hasMedia = hasTabsModule(contentModules, SectionModuleTypeEnum.MEDIA);
    const hasText = hasTabsModule(contentModules, SectionModuleTypeEnum.TEXT);
    if (!hasMedia || hasText) return null;

    const deviceType = tab?.media?.mockupSettings?.deviceType;
    if (!deviceType) return getTabsImageOnlyColumnSpan(aspectRatio);
    return MOBILE_MOCKUP_TYPES.has(deviceType) ? 6 : 8;
}

export function getTabsMediaAndTextContentStyle(tab, modules) {
    const contentModules = getTabsContentModules(modules);
    const hasMedia = hasTabsModule(contentModules, SectionModuleTypeEnum.MEDIA);
    const hasText = hasTabsModule(contentModules, SectionModuleTypeEnum.TEXT);
    if (!hasMedia || !hasText) return null;

    const deviceType = tab?.media?.mockupSettings?.deviceType;
    if (MOBILE_MOCKUP_TYPES.has(deviceType)) return {gridColumn: "2 / span 10"};
    if (WIDE_MOCKUP_TYPES.has(deviceType)) return {gridColumn: "1 / span 12"};
    return null;
}

export function getTabsSectionContentStyle(tab, modules, aspectRatio = "16_9") {
    const mixedContentStyle = getTabsMediaAndTextContentStyle(tab, modules);
    if (mixedContentStyle) return mixedContentStyle;

    const columnSpan = getTabsMediaOnlyColumnSpan(tab, modules, aspectRatio);
    if (!columnSpan) return null;

    const columnStart = Math.floor((12 - columnSpan) / 2) + 1;
    return {
        gridColumn: `${columnStart} / span ${columnSpan}`
    };
}
